import type { FilterField } from '@/components/common/AdvancedFilter';
import { STATUS_COLOR_CLASS } from '@/styles/statusColors';

export const ATTENDANCE_STATUS = ['P', 'L', 'A', 'W', 'H'] as const;
export type AttendanceStatus = (typeof ATTENDANCE_STATUS)[number];

export const STATUS_COLORS = {
  P: { badge: STATUS_COLOR_CLASS.success, text: 'text-palette-emerald' },
  L: { badge: STATUS_COLOR_CLASS.warning, text: 'text-palette-amber' },
  A: { badge: STATUS_COLOR_CLASS.danger, text: 'text-destructive' },
  W: { badge: STATUS_COLOR_CLASS.neutral, text: 'text-muted-foreground' },
  H: { badge: STATUS_COLOR_CLASS.info, text: 'text-info-foreground' },
} satisfies Record<AttendanceStatus, { badge: string; text: string }>;

export const DAILY_DASHBOARD_FILTER_FIELDS: FilterField[] = [
  {
    key: 'status',
    label: 'Status',
    type: 'select',
    placeholder: 'All',
    options: [
      { label: 'Present', value: 'P' },
      { label: 'Late', value: 'L' },
      { label: 'Absent', value: 'A' },
      { label: 'Weekend', value: 'W' },
      { label: 'Holiday', value: 'H' },
    ],
  },
  { key: 'division', label: 'Division', type: 'text', placeholder: 'Division' },
  { key: 'district', label: 'District', type: 'text', placeholder: 'District' },
];

export const JOB_CARD_FILTER_FIELDS: FilterField[] = [
  { key: 'name', label: 'Name', type: 'text', placeholder: 'ZM or AM name' },
  { key: 'division', label: 'Division', type: 'text', placeholder: 'Division' },
  { key: 'district', label: 'District', type: 'text', placeholder: 'District' },
];
